import { useCallback, useState } from 'react';

/**
 * A value held still while a menu is open: `capture` on open, `release` on
 * close, and `snapshot` falls back to the live value while closed.
 *
 * What a selected-first menu sorts by. Sorting by the live selection moves a
 * row to the top the moment it is ticked, so the next click lands on whatever
 * slid under the pointer; the new order shows the next time the menu opens.
 */
export const useOpenSnapshot = <T>(live: T) => {
  const [captured, setCaptured] = useState<{ value: T } | null>(null);

  const capture = useCallback(
    (value: T = live) => setCaptured({ value }),
    [live]
  );
  const release = useCallback(() => setCaptured(null), []);

  return { snapshot: captured ? captured.value : live, capture, release };
};
